// extracted by mini-css-extract-plugin
module.exports = {"default":"a8wk27","simple-image-container":"CXW8mj","simple-image":"_396cs4","simple-image-loaded":"_3exPp9","flexible-width":"_21_khk"};